export const ITEMS_WITHOUT_SCROLL = 2;
export const TRANSITION_TIMEOUT_MS = 300;
//# sourceMappingURL=constants.js.map